export default __webpack_public_path__ + "static/media/gallery-img8.2d01a1f5.jpeg";